import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import { Tunnel } from "react-tunnels";
import { Alert } from "antd";
import { css } from "glamor";
import { Fetch } from "../../api";

import ResearchRequestForm from "../../container/ResearchRequestForm";

const styles = {
    conflictAlert: css({
        marginBottom: "20px",
    }),
};

class EditResearchRequestForm extends React.Component {
    state = {
        ulid: null,
        createError: null,
    };

    onSubmit = e => {
        e.preventDefault();

        const form = this.formRef.props.form;
        form.validateFields((err, values) => {
            if (!err) {
                this.createRequest(values);
            }
        });
    };

    createRequest = async data => {
        const req = new Request(this.props.actionUrl, {
            method: "POST",
            body: JSON.stringify(data),
        });

        try {
            const response = await Fetch(req);
            this.setState({ ulid: response.ulid });
        } catch (e) {
            this.setState({ createError: e });
        }
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    redirectToList = () => this.props.history.push("/");

    render() {
        const isConflict =
            R.pathOr(false, ["response", "status"], this.state.createError) ===
            409;

        if (this.state.createError && !isConflict) {
            return <div>{this.state.createError.message}</div>;
        } else if (this.state.ulid) {
            return <Redirect to={`/tickets/${this.state.ulid}/`} />;
        }

        const conflictMessage = this.props.conflictMessage || null;
        const getConflictDescription =
            this.props.getConflictDescription || (() => null);

        return (
            <React.Fragment>
                {isConflict ? (
                    <Alert
                        message={conflictMessage}
                        description={getConflictDescription(this.formRef)}
                        type="error"
                        closable
                        onClose={this.redirectToList}
                        showIcon
                        className={`${styles.conflictAlert}`}
                    />
                ) : null}
                <Tunnel id={this.props.titlePlacement || "bluebar-title"}>
                    {this.props.title}
                </Tunnel>
                <ResearchRequestForm
                    {...this.props}
                    wrappedComponentRef={this.saveFormRef}
                    onSubmit={this.onSubmit}
                />
            </React.Fragment>
        );
    }
}

EditResearchRequestForm.propTypes = {
    actionUrl: PropTypes.string,
    wrappedComponentRef: PropTypes.func,
};

export default EditResearchRequestForm;
